import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';
import { useNavigate } from 'react-router';

export default function MarketplaceCheckoutCancelPage() {
    const navigate = useNavigate();
    return (
        <div className="p-6 flex justify-center">
            <Card className="max-w-md w-full">
                <CardContent className="py-12 text-center space-y-4">
                    <XCircle className="w-16 h-16 mx-auto text-amber-500" />
                    <h2 className="text-xl font-semibold">
                        Checkout Canceled
                    </h2>
                    <p className="text-muted-foreground">
                        Your checkout was canceled. No charges were made.
                    </p>
                    <Button onClick={() => navigate('/marketplace')}>
                        Back to Marketplace
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
